/* eslint-disable max-lines */
import { capitalize } from 'lodash';
import React from 'react';
import type { User } from 'types';
import { userRolesToTypes } from 'utils/userRoles';
import renderInsight, { renderPrevent } from 'utils/userStrings';

type ComponentProps = {
  user: User;
  selectedUsers: User[];
  handleSelectUser: (event: React.ChangeEvent<HTMLInputElement>, user: User) => void;
};

const UserPermissionsTableRow: React.FC<ComponentProps> = ({
  user,
  selectedUsers,
  handleSelectUser,
}) => {
  const renderTeamNames = (): string => {
    // @ts-ignore
    const divisions = user.teams?.filter((t) => t.kind === 'division') ?? [];

    if (divisions.length === 0) {
      return '–';
    }

    return divisions.map((t) => t.name).join(', ');
  };

  const renderRegionNames = (): string => {
    // @ts-ignore
    const regions = user.teams?.filter((t) => t.kind === 'region') ?? [];

    if (regions.length === 0) {
      return '–';
    }

    return regions.map((t) => t.name).join(', ');
  };

  const renderManagementLevelNames = (): string => {
    if (!user.teams?.length) return '';

    const levels = user.teams
      // @ts-ignore
      .filter((t) => t.kind === 'management-level')
      .map((t) => t.name);

    if (!levels.length) return '';

    return `(${levels.join(', ')})`;
  };

  return (
    <tr key={user.uuid} className="table-wrapper__new-tr table-row align-top">
      <td className="table-wrapper__new-td">
        <div className="table-wrapper__new-cell-content h-12 flex">
          <input
            id={`checkbox-user-${user.uuid}`}
            data-testid="select-button"
            type="checkbox"
            className="cursor-pointer form-checkbox litlingo-checkbox w-5 h-5"
            onClick={(e): void => e.stopPropagation()}
            onChange={(e): void => {
              handleSelectUser(e, user);
            }}
            checked={!!selectedUsers.find((u) => u.uuid === user.uuid)}
          />
        </div>
      </td>

      <td className="table-wrapper__new-td">
        <div className="table-wrapper__new-cell-content h-auto pr-4 flex flex-col text-body">
          <div className="w-full truncate">
            {user.name} {renderManagementLevelNames()}
          </div>
          <div className="w-full truncate">{user.email}</div>
        </div>
      </td>
      <td className="table-wrapper__new-td">
        <div className="table-wrapper__new-cell-content h-12 pr-4 flex items-center">
          <div className="text-body clamped-text-2">
            {user.roles != null && userRolesToTypes(user.roles).length > 0
              ? userRolesToTypes(user.roles)
                  .map((item) => capitalize(item.label))
                  .join(', ')
              : '–'}
          </div>
        </div>
      </td>
      <td className="table-wrapper__new-td">
        <div className="table-wrapper__new-cell-content h-12 pr-4 flex items-center">
          <div className="text-left text-body clamped-text-2">{renderTeamNames()}</div>
        </div>
      </td>
      <td className="table-wrapper__new-td">
        <div className="table-wrapper__new-cell-content h-12 pr-4 flex items-center">
          <div className="text-left text-body clamped-text-2">{renderRegionNames()}</div>
        </div>
      </td>
      <td className="table-wrapper__new-td">
        <div className="table-wrapper__new-cell-content h-12 pr-4 flex items-center text-body">
          {renderInsight(user)}
        </div>
      </td>
      <td className="table-wrapper__new-td">
        <div className="table-wrapper__new-cell-content h-12 pr-4 flex items-center text-body">
          {renderPrevent(user)}
        </div>
      </td>
    </tr>
  );
};

export default UserPermissionsTableRow;
